import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
  const navigate = useNavigate();

  return (
    <header className="navbar" role="navigation">
      <div className="logo" onClick={() => navigate('/')}>LogiSim</div>
      <nav className="nav-links">
        <div className="nav-item" onClick={() => navigate('/')}>Home</div>
        <div className="nav-item" onClick={() => navigate('/simulations')}>Simulations</div>
        <div className="nav-item" onClick={() => navigate('/about')}>About</div>
        <div className="nav-item nav-item-disabled">Contact</div>
        <div className="nav-item nav-item-disabled">Login/Sign Up</div>
      </nav>
    </header>
  );
};

export default NavBar; 